// app.routes.ts
import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuard } from './core/guards/auth.guard';
import { DynamicAuthGuard } from './core/guards/dynamic-auth.guard';


export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./public-app/public-app.module').then(m => m.PublicAppModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./private-app/private-app-routing.module').then(m => m.PrivateAppRoutingModule),
    canActivate: [DynamicAuthGuard]
  }
];
